module.exports = __webpack_public_path__ + "img/right_angle_corner_arrow_line_icon.fab4a47c.svg";